export const getIsLoading = ( state ) => {
    return state.isLoading;
}

export const getGeneratorRules = ( state ) => {
    return state.generatorRules;
}

export const getGeneratorRuleTypes = ( state ) => {
    return state.generatorRuleTypes;
}
